var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47123 6.37502C7.47123 6.11612 7.26135 5.90625 7.00246 5.90625C6.74357 5.90625 6.53369 6.11612 6.53369 6.37502V10.1252C6.53369 13.1456 8.98222 15.5941 12.0026 15.5941C15.0231 15.5941 17.4716 13.1456 17.4716 10.1252V6.37502C17.4716 6.11612 17.2617 5.90625 17.0028 5.90625C16.7439 5.90625 16.5341 6.11612 16.5341 6.37502V10.1252C16.5341 12.6278 14.5053 14.6566 12.0026 14.6566C9.50001 14.6566 7.47123 12.6278 7.47123 10.1252V6.37502Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00246 17.1567C6.74357 17.1567 6.53369 17.3665 6.53369 17.6254C6.53369 17.8843 6.74357 18.0942 7.00246 18.0942H17.0028C17.2617 18.0942 17.4716 17.8843 17.4716 17.6254C17.4716 17.3665 17.2617 17.1567 17.0028 17.1567H7.00246Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47123 6.37502C7.47123 6.11612 7.26135 5.90625 7.00246 5.90625C6.74357 5.90625 6.53369 6.11612 6.53369 6.37502V10.1252C6.53369 13.1456 8.98222 15.5941 12.0026 15.5941C15.0231 15.5941 17.4716 13.1456 17.4716 10.1252V6.37502C17.4716 6.11612 17.2617 5.90625 17.0028 5.90625C16.7439 5.90625 16.5341 6.11612 16.5341 6.37502V10.1252C16.5341 12.6278 14.5053 14.6566 12.0026 14.6566C9.50001 14.6566 7.47123 12.6278 7.47123 10.1252V6.37502Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00246 17.1567C6.74357 17.1567 6.53369 17.3665 6.53369 17.6254C6.53369 17.8843 6.74357 18.0942 7.00246 18.0942H17.0028C17.2617 18.0942 17.4716 17.8843 17.4716 17.6254C17.4716 17.3665 17.2617 17.1567 17.0028 17.1567H7.00246Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.3660693c4f9539b7f49e00fb852f1628.svg";
export { ForwardRef as ReactComponent };